"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orElseForResult = void 0;
/**
 *  Calls _recoverer_ and return its returned value if _input_ is `Err(E)`,
 *  otherwise returns _input_ as `Ok(T)`.
 *  This function can be used for control flow based on result values.
 */
function orElseForResult(input, recoverer) {
    if (input.ok) {
        return input;
    }
    var fallback = recoverer(input.err);
    return fallback;
}
exports.orElseForResult = orElseForResult;
